import * as yup from "yup";

export const formularioVam = yup.object().shape({
    a1: yup.string().required("Favor seleccione"),
    a2: yup.string().required("Favor seleccione"),
    a3: yup.string().required("Favor seleccione"),
    diagnostico: yup.string().required("Ingrese este campo"),
    celularT: yup.string().required("Ingrese este campo"),
    escanea: yup.string().required("Ingrese este campo"),
    subject: yup.string().required("Ingrese este campo"),
});

export const formularioCredito = yup.object().shape({
    a1: yup.string().required("Favor seleccione"),
    a2: yup.string().required("Favor seleccione"),
    a3: yup.string().required("Favor seleccione"),
    diagnostico: yup.string().required("Ingrese este campo"),
    //celularC: yup.string().required("Ingrese este campo"),
    centroMedico: yup.string().required("Ingrese este campo"),
    escanea: yup.string().required("Ingrese este campo"),
    subject: yup.string().required("Ingrese este campo"),
});
